<template>
    <div>

    </div>
</template>
<script>
import { actionSheetController, modalController } from '@ionic/vue';
import { camera, calculator, folderOutline, cubeOutline } from 'ionicons/icons';
import CreateObservation from '../views/observations/Create.vue';
import CreateMeasurement from '../views/measurements/Create.vue';
import CreateLocationItem from '../views/location_items/Create.vue';
import CreateLocationItemComponent from '../views/location_item_components/Create.vue';
import { db } from '../services/db';
export default {
    data() {
        return {
            calculator,
            camera,
            folderOutline,
            cubeOutline
        }
    },
    methods: {
        async actions() {
            // check if we want to add measurements
            const measurements_enabled = this.$store.getters.checkSetting('measurements');
            const observations_enabled = this.$store.getters.checkSetting('observations');

            let buttons = [
                // {
                //     text: 'Component toevoegen',
                //     role: 'save',
                //     id: 'add-component-button',
                //     icon: cubeOutline,
                //     handler: () => {
                //         this.createComponent()
                //     },
                // },
                {
                    text: 'Waarneming toevoegen',
                    role: 'save',
                    id: 'save-button',
                    icon: camera,
                    data: {
                        type: 'save'
                    },
                    handler: () => {
                        this.createObservation()
                    },
                },
                {
                    text: 'Meting toevoegen',
                    role: 'save',
                    id: 'save-button',
                    icon: calculator,
                    data: {
                        type: 'save'
                    },
                    handler: () => {
                        this.createMeasurement()
                    },
                },
                {
                    text: 'Annuleren',
                    role: 'cancel',
                    handler: () => {
                        // console.log('Cancel clicked')
                    },
                },
            ]

            if (!measurements_enabled) {
                buttons.splice(3, 1)
            }

            if (!observations_enabled) {
                buttons.splice(2, 1)
            }


            const actionSheet = await actionSheetController
                .create({
                    cssClass: 'action-sheet-class',
                    mode: 'ios',
                    buttons: buttons
                });
            await actionSheet.present();
        },
        async createObservation() {
            // const modal = await modalController.create({
            //     component: CreateObservation,
            //     componentProps: {
            //         inspection_id: parseInt(this.$route.params.id),
            //     },
            //     initialBreakpoint: 1,
            //     breakpoints: [0, 1]
            // }
            // );
            // modal.present();

            // const { data, role } = await modal.onWillDismiss();

            this.$router.push({ name: 'observation-create', params: { inspection_id: parseInt(this.$route.params.id) } })

        },
        async createMeasurement() {
            // const modal = await modalController.create({
            //     component: CreateMeasurement,
            //     componentProps: {
            //         inspection_id: parseInt(this.$route.params.id),
            //     },
            //     breakpoints: [0, 1],
            //     initialBreakpoint: 1,
            // }
            // );
            // modal.present();

            // const { data, role } = await modal.onWillDismiss();

            this.$router.push({ name: 'measurement-create', params: { inspection_id: parseInt(this.$route.params.id) } })

        },
        async createBouwdeel() {
            // Get the current inspection ID and location ID from the route
            const inspectionId = parseInt(this.$route.params.id);
            const locationId = parseInt(this.$route.query.location_id);
            
            // Create a modal to add a Bouwdeel
            const modal = await modalController.create({
                component: CreateLocationItem,
                componentProps: {
                    parent_uuid: null, // No parent for top-level Bouwdeel
                    inspection_id: inspectionId,
                    location_id: locationId,
                    order_id: 1, // Will be adjusted in component
                },
                initialBreakpoint: 1,
                breakpoints: [0, 1],
            });
            
            await modal.present();
            
            const { role } = await modal.onWillDismiss();
            if (role === 'confirm') {
                // Refresh component count
                this.$store.dispatch('setComponentCountKey');
            }
        },
        async createComponent() {
            // Get the current inspection ID and location ID
            const inspectionId = parseInt(this.$route.params.id);
            const locationId = parseInt(this.$route.query.location_id);
            
            // Get the first location item for this location to use as parent
            let locationItem = await this.getFirstLocationItem(locationId);
            
            if (!locationItem) {
                this.$toast.error('Geen bouwdeel gevonden. Maak eerst een bouwdeel aan.');
                return;
            }
            
            // Create a modal to add a Component
            const modal = await modalController.create({
                component: CreateLocationItemComponent,
                componentProps: {
                    parent_uuid: null, // Will be determined in component
                    location_item_uuid: null,
                    parent: true, // Create as parent component
                },
                initialBreakpoint: 1,
                breakpoints: [0, 1],
            });
            
            await modal.present();
            
            const { role } = await modal.onWillDismiss();
            if (role === 'confirm') {
                // Refresh component count
                this.$store.dispatch('setComponentCountKey');
            }
        },
        async getFirstLocationItem(locationId) {
            // Get the first location item for this location
            try {
                const locationItems = await db.location_items
                    .where('location_id')
                    .equals(parseInt(locationId))
                    .toArray();
                    
                return locationItems.length > 0 ? locationItems[0] : null;
            } catch (error) {
                console.error('Error fetching location items:', error);
                return null;
            }
        },
    }
}
</script>
<style lang="">

</style>
